import { BACKEND_URL } from "../config";
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = `${BACKEND_URL}/api`;

function UpgradeSubscription() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleUpgrade = async () => {
    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      const originUrl = window.location.origin;

      const response = await axios.post(
        `${API}/payments/create-checkout`,
        {
          package_id: 'tier1',
          origin_url: originUrl
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success && response.data.checkout_url) {
        // Redirect to Stripe checkout
        window.location.href = response.data.checkout_url;
      } else {
        setError(response.data.message || 'Failed to create checkout session');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to initiate payment');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      fontFamily: "'Inter', sans-serif"
    }}>
      <div style={{
        width: '100%',
        maxWidth: '600px',
        background: 'white',
        borderRadius: '20px',
        padding: '3rem',
        boxShadow: '0 10px 40px rgba(139, 92, 246, 0.2)',
        border: '2px solid #e9d5ff'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 style={{
            fontSize: '2rem',
            fontWeight: '900',
            background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '0.5rem'
          }}>
            Upgrade to Tier 1
          </h1>
          <p style={{ color: '#64748b', fontSize: '1rem' }}>
            Unlock unlimited access and premium features
          </p>
        </div>

        {/* Error Message */}
        {error && (
          <div style={{
            padding: '1rem',
            background: '#fee2e2',
            border: '1px solid #fecaca',
            borderRadius: '8px',
            color: '#991b1b',
            fontSize: '0.875rem',
            marginBottom: '1.5rem',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        {/* Pricing Card */}
        <div style={{
          background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
          borderRadius: '16px',
          padding: '2rem',
          color: 'white',
          marginBottom: '2rem'
        }}>
          <div style={{ fontSize: '3rem', fontWeight: '900', marginBottom: '0.5rem' }}>
            $29.99<span style={{ fontSize: '1.25rem', fontWeight: '400' }}>/month</span>
          </div>
          <div style={{ fontSize: '0.875rem', opacity: 0.9 }}>
            Billed monthly • Cancel anytime
          </div>
        </div>

        {/* Features List */}
        <div style={{ marginBottom: '2rem' }}>
          <h3 style={{ fontSize: '1.125rem', fontWeight: '700', color: '#374151', marginBottom: '1rem' }}>
            What's Included:
          </h3>
          {[
            { icon: '♾️', text: 'Unlimited trade calculations per day' },
            { icon: '🤖', text: 'Full MT5 integration & automation' },
            { icon: '📊', text: 'Advanced performance analytics' },
            { icon: '⚡', text: 'Automated breakout detection' },
            { icon: '🎯', text: 'Smart trailing stop loss' },
            { icon: '🔄', text: 'Real-time market data updates' },
            { icon: '💡', text: 'Self-improving AI recommendations' }
          ].map((feature, idx) => (
            <div key={idx} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              padding: '0.75rem',
              marginBottom: '0.5rem',
              background: '#f9fafb',
              borderRadius: '8px'
            }}>
              <span style={{ fontSize: '1.5rem' }}>{feature.icon}</span>
              <span style={{ color: '#374151' }}>{feature.text}</span>
            </div>
          ))}
        </div>

        {/* Upgrade Button */}
        <button
          onClick={handleUpgrade}
          disabled={loading}
          style={{
            width: '100%',
            padding: '1rem',
            background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1.125rem',
            fontWeight: '700',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1,
            transition: 'all 0.3s ease',
            marginBottom: '1rem'
          }}
          onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
          onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
        >
          {loading ? 'Processing...' : 'Upgrade Now 🚀'}
        </button>

        {/* Security Badge */}
        <div style={{
          textAlign: 'center',
          padding: '1rem',
          background: '#f3e8ff',
          borderRadius: '8px',
          marginBottom: '1rem'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
            <span style={{ fontSize: '1rem' }}>🔒</span>
            <span style={{ color: '#7c3aed', fontSize: '0.875rem', fontWeight: '600' }}>
              Secure Payment via Stripe
            </span>
          </div>
          <div style={{ fontSize: '0.75rem', color: '#64748b' }}>
            Your payment information is encrypted and secure
          </div>
        </div>

        {/* Back Button */}
        <div style={{ textAlign: 'center' }}>
          <button
            onClick={() => navigate('/calculator')}
            style={{
              background: 'none',
              border: 'none',
              color: '#64748b',
              fontSize: '0.875rem',
              cursor: 'pointer'
            }}
          >
            ← Back to Calculator
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpgradeSubscription;
